export default __webpack_public_path__ + "static/media/icon.d3dbbb3d.png";